import React from 'react';

const facts = [
  { icon: 'bed', label: '3 a 4', sub: 'recámaras' },
  { icon: 'square_foot', label: '127.5 m²', sub: 'lote tipo' },
  { icon: 'home_work', label: 'desde 143 m²', sub: 'construcción' },
  { icon: 'place', label: 'Pachuca', sub: 'a 10 min del centro' },
];

export default function HeroQuickFacts() {
  return (
    <div className="hero-quickfacts" data-testid="hero-quickfacts">
      {facts.map((f, i) => (
        <div key={i} className="qf-item" data-testid={`qf-item-${i}`}>
          <span className="icon-font qf-icon">{f.icon}</span>
          <div className="qf-text">
            <div className="qf-label">{f.label}</div>
            <div className="qf-sub">{f.sub}</div>
          </div>
        </div>
      ))}
    </div>
  );
}
